"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItemText = exports.SubMenuItemIcon = exports.SubMenuItemBadges = exports.SubMenuItemAction = exports.SubMenuItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _Text = require("../Text");
var _Truncate = require("../Truncate");
var _SubMenuModule = _interopRequireDefault(require("./SubMenu.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Type definitions for submenu item child components

const SubMenuItemIcon = _ref => {
  let {
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
    ...props,
    size: "small",
    color: _Text.TEXT_COLORS.inverseSecondary,
    className: (0, _classify.default)(_SubMenuModule.default.menuIcon, className)
  });
};
exports.SubMenuItemIcon = SubMenuItemIcon;
SubMenuItemIcon.displayName = 'SubMenuItemIcon';
const SubMenuItemText = _ref2 => {
  let {
    children,
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.ButtonTextMedium, {
    ...props,
    className: (0, _classify.default)(_SubMenuModule.default.subMenuItemText, className),
    color: _Text.TEXT_COLORS.inversePrimary,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Truncate.Truncate, {
      showFullTextOnHover: true,
      children: children
    })
  });
};
exports.SubMenuItemText = SubMenuItemText;
SubMenuItemText.displayName = 'SubMenuItemText';
const SubMenuItemBadges = _ref3 => {
  let {
    children,
    className,
    ...props
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    className: (0, _classify.default)(_SubMenuModule.default.subMenuItemBadges, className),
    children: children
  });
};
exports.SubMenuItemBadges = SubMenuItemBadges;
SubMenuItemBadges.displayName = 'SubMenuItemBadges';
const SubMenuItemAction = exports.SubMenuItemAction = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    children,
    className,
    ...props
  } = _ref4;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    className: (0, _classify.default)(_SubMenuModule.default.actionItems, className),
    ref: ref,
    children: children
  });
});
SubMenuItemAction.displayName = 'SubMenuItemAction';
const SubMenuItem = exports.SubMenuItem = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    children,
    selectedMenuKey,
    disabled,
    classNames,
    onChange,
    menuKey,
    ...props
  } = _ref5;
  const onChangeHandler = () => {
    if (!disabled) {
      onChange?.(menuKey);
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      onChangeHandler();
    }
  };
  const selected = selectedMenuKey === menuKey;
  const getNamedComp = comp => {
    const childrenArray = React.Children.toArray(children);
    if (childrenArray.length) {
      const nodes = [];
      for (const child of childrenArray) {
        if (/*#__PURE__*/React.isValidElement(child)) {
          const childWithType = child;
          if (childWithType?.type?.displayName === comp) {
            nodes.push(/*#__PURE__*/React.cloneElement(child, {
              selected,
              disabled
            }));
          }
        }
      }
      return nodes.length > 1 ? nodes : nodes[0];
    }
    return null;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ...props,
    className: (0, _classify.default)(_SubMenuModule.default.menuItem, {
      [_SubMenuModule.default.selected]: selected,
      [_SubMenuModule.default.disabled]: disabled
    }, classNames?.wrapper),
    onKeyDown: onKeyDownHandler,
    onClick: onChangeHandler,
    tabIndex: disabled ? -1 : 0,
    ref: ref,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _SubMenuModule.default.menuIconName,
      children: [getNamedComp('SubMenuItemIcon'), getNamedComp('SubMenuItemText'), getNamedComp('SubMenuItemBadges')]
    }), getNamedComp('SubMenuItemAction')]
  });
});